// extracted by mini-css-extract-plugin
export default {"formContainer":"Login_formContainer__+uNf2","title":"Login_title__BwnHF","login-form":"Login_login-form__mX81b","login-button":"Login_login-button__zl-Up"};